export function ShowArchiveIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="currentColor" d="M12 16.5a2 2 0 100-4 2 2 0 000 4z"></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 6V5a3 3 0 013-3h2a3 3 0 013 3v1h3a1 1 0 110 2v5.271l.581.415a1 1 0 010 1.628l-.581.415V19a3 3 0 01-3 3H8a3 3 0 01-3-3v-3.271l-.581-.415a1 1 0 010-1.628L5 13.271V8a1 1 0 010-2h3zm2-1a1 1 0 011-1h2a1 1 0 011 1v1h-4V5zM7 8h10v3.842l-1.513-1.08a6 6 0 00-6.974 0L7 11.842V8zm0 6.3l2.675-1.91a4 4 0 014.65 0L17 14.3v.4l-2.675 1.91a4 4 0 01-4.65 0L7 14.7v-.4zm0 2.857V19a1 1 0 001 1h8a1 1 0 001-1v-1.843l-1.513 1.08a6 6 0 01-6.974 0L7 17.158z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
